import { jsx } from 'panel';
import { TextHighlightEl } from 'common/components/text-highlight';
import { TooltipItemType } from './types';

function ChartTooltipItem(_ref) {
  let {
    item,
    key
  } = _ref;

  if (item.type === TooltipItemType.Data) {
    return jsx(TextHighlightEl, {
      sel: '.item',
      key: key,
      attrs: {
        theme: item.theme ? item.theme : "neutral",
        text: item.text
      }
    });
  }

  return jsx("span", {
    sel: '.item',
    key: key,
    class: {
      ["section-".concat(item.type)]: true
    }
  }, item.text);
}

export function template() {
  return jsx("div", {
    sel: '.wrapper',
    class: {
      'is-compact': this.attr("is-compact")
    }
  }, jsx("div", {
    sel: '.body'
  }, this.attr("title-color") ? jsx("div", {
    sel: '.color-indicator',
    style: {
      'background-color': this.attr("title-color")
    },
    attrs: {
      elref: "titleColorIndicator"
    }
  }) : null, jsx("div", {
    sel: '.sections',
    attrs: {
      elref: "sections"
    }
  }, this.attr("sections").map((section, sectionIdx) => {
    var _a;

    return jsx("div", {
      sel: '.section-container',
      key: sectionIdx
    }, section.bulletColor ? jsx("div", {
      sel: '.section-color-indicator',
      style: this.helpers.getItemBackground(section)
    }) : null, jsx("div", {
      sel: '.section-rows-container'
    }, (_a = section.rows) === null || _a === void 0 ? void 0 : _a.map((row, rowIdx) => jsx("div", {
      sel: '.section-row-container',
      key: rowIdx
    }, row.items.map((item, itemIdx) => jsx(ChartTooltipItem, {
      item: item,
      key: itemIdx
    }))))));
  }))), this.attr("footer-text") ? jsx("div", {
    sel: '.footer',
    attrs: {
      elref: "footer"
    }
  }, jsx("span", null, this.attr("footer-text"))) : null);
}